import React, {createContext, PropsWithChildren, useMemo, useState} from 'react';
import {setDatadogUser} from '../logger';
import {AccountAuthDetails} from '../models';
import {AccountService, AccountServiceImpl} from '../services';

export interface AccountContextInterface {
  accountAuth?: AccountAuthDetails;
  accountService: AccountService;
  storeAccountAuth: (auth: AccountAuthDetails) => void;
}

export const AccountContext = createContext<AccountContextInterface>(undefined as any as AccountContextInterface);

export const AccountContextProvider: React.FC<PropsWithChildren<{}>> = ({children}) => {
  const accountService: AccountService = useMemo(() => new AccountServiceImpl(), []);
  const [accountAuth, setAccountAuth] = useState<AccountAuthDetails>();

  /**
   * @description Function to store auth.
   * @param data account id & token passed to be stored.
   * @returns {void}
   */
  const storeAccountAuth = async (data: AccountAuthDetails): Promise<void> => {
    setAccountAuth(data);
    setDatadogUser(data?.id ? {id: data.id} : null);
  };

  return <AccountContext.Provider value={{accountAuth, accountService, storeAccountAuth}}>{children}</AccountContext.Provider>;
};
